export default __webpack_public_path__ + "media/images/icons_fc/todo-5993ceef696df9b3485281f10f0f7bc5.png";